import * as React from 'react';
import Typography from "@mui/material/Typography";

type Props = {

};

export const ErrorComponent = (props: Props) => {

    return (
        <Typography variant={'h1'} justify={'center'} align={'center'}>
        </Typography>
    );
};
